import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';
import { toast } from 'react-toastify';

export const { setDataProcessingMergeData, setDataProcessingMergeStatus } = slice.actions;

const dataProcessingMerge = (params: any, url: any) => async () => {
  try {
    const response = await API.dataProcessingMerge.dataProcessingMerge(params, url);
    dispatch(setDataProcessingMergeData(response.data));
    dispatch(setDataProcessingMergeStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    if (error.response.status === 422) {
      toast.error(error.response.data.message);
    }
  }
};

export default {
  dataProcessingMerge
};
